
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-outta-here",
      function () {
        return require("private-next-pages/get-outta-here/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-outta-here"])
      });
    }
  